var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hot-button"},[_c('div',{class:['top-scroll-speed', { 'is-active': _vm.isSticky }],on:{"click":_vm.backToTop}},[_c('b-icon',{staticClass:"icon-color",attrs:{"icon":"arrow-up"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }